import axios from '../base/axios';
import API_KEY from './key';

const GET_POPULAR = 'flixfrenzy/redux/GET_POPULAR';

// eslint-disable-next-line default-param-last
const popularReducer = (state = [], action) => {
  switch (action.type) {
    case GET_POPULAR:
      return action.payload;
    default:
      return state;
  }
};

export const getPopular = () => (dispatch) => {
  axios.get(`movie/popular?api_key=${API_KEY}&language=en-US`).then((res) => {
    dispatch({
      type: GET_POPULAR,
      payload: res.data,
    });
  });
};

export default popularReducer;
